// extracted by mini-css-extract-plugin
module.exports = {"textBlock":"TextBlock-module--textBlock--1eYjy","textBlockContent":"TextBlock-module--textBlockContent--2p5NX"};